export default __webpack_public_path__ + "static/media/about_us.13b7a2c5.svg";